export default function initFreeform() {
	const forms = document.querySelectorAll('.freeform-form');
	forms.forEach((form) => {
		form.addEventListener('freeform-field-table-after-row-added', function (event) {
			const row = event.row;
			const jcfSelect = row.querySelectorAll('.jcf-select');
			if (jcfSelect.length > 0) {
				jcf.destroyAll(row);
				jcfSelect.forEach((el) => el.remove());
				jcf.replaceAll(row);
			}
		});
	});

	document.addEventListener('freeform-ready', (event) => {
		// scrolling offset in pixels from the top of the form.
		// defaults to 0
		event.options.scrollOffset = -200;
	});
}
